/**
 * Merge-field substitution mirror for live preview in the campaign/template
 * editors. Final substitution always happens CRM-side before dispatch
 * (packages/backend/src/services/campaigns/merge.ts is the source of truth);
 * this copy exists only so the editor can preview without a round trip, and
 * must stay byte-for-byte identical to the backend's token semantics.
 * Token syntax: {{field}} or {{field|fallback}}. Missing value with no
 * fallback renders as '' and is reported so the editor can flag it.
 */

const TOKEN_RE = /\{\{\s*([a-z_]+)\s*(?:\|([^}]*))?\}\}/g;

export interface MergeTextResult {
  text: string;
  missing: string[];
}

export function renderMergeText(
  template: string,
  values: Record<string, string | null | undefined>,
): MergeTextResult {
  const missing = new Set<string>();
  const text = template.replace(TOKEN_RE, (_m, name: string, fallback?: string) => {
    const v = values[name];
    if (v != null && v !== '') return v;
    if (fallback !== undefined) return fallback;
    missing.add(name);
    return '';
  });
  return { text, missing: [...missing] };
}
